"use server";

import { sdk } from "@/lib/medusa";
import { getAuthHeaders } from "@/lib/data/cookies";
import { withSession } from "@/lib/data/session";
import { StoreFavorite } from "../models/store-favorite";

export async function getFavoritesList() {
  const headers = await getAuthHeaders();

  return sdk.client
    .fetch<{ favorites: StoreFavorite[] }>("/store/favorites", {
      method: "GET",
      headers,
      cache: "no-store",
    })
    .then((res) => res.favorites);
}

export async function addFavorite(productId: string) {
  const headers = await getAuthHeaders();

  return withSession(() =>
    sdk.client.fetch("/store/favorites", {
      method: "POST",
      headers,
      body: { product_id: productId },
    })
  );
}

export async function removeFavorite(id: string) {
  const headers = await getAuthHeaders();

  return withSession(() =>
    sdk.client.fetch(`/store/favorites/${id}`, {
      method: "DELETE",
      headers,
    })
  );
}
